module.exports = __webpack_public_path__ + "img/t2.0a50af66.png";